import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { commandsApi } from '@/api/commandsApi';
import type { CommandListRequest, CreateCommandRequest } from '@/types/command';

const KEYS = {
  all: ['commands'] as const,
  list: (f: CommandListRequest) => [...KEYS.all, 'list', f] as const,
  detail: (id: number) => [...KEYS.all, 'detail', id] as const,
};

export function useCommands(filters: CommandListRequest = {}) {
  return useQuery({
    queryKey: KEYS.list(filters),
    queryFn: () => commandsApi.list(filters),
    refetchInterval: 5000, // Refresca cada 5seg para ver cambios de estado
  });
}

export function useCreateCommand() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (r: CreateCommandRequest) => commandsApi.create(r),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
      qc.invalidateQueries({ queryKey: ['devices'] });
    },
  });
}

export function useCancelCommand() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => commandsApi.cancel(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}
